<div class="flex-row">
    <ng-container
        *ngrxLet="currentHierarchicalSelectionNodeItem$ as currentHierarchicalSelectionNodeItem"
    >
        <ng-container
            *ngrxLet="currentHierarchicalSelectionIsRoot$ as currentHierarchicalSelectionIsRoot"
        >
            <cds-select layout="vertical" controlWidth="stretch">
                <label>Saved levels</label>
                <select
                    name="hierarchical-selection-node"
                    class="selection-node-select"
                    [ngModel]="currentHierarchicalSelectionNodeItem"
                    [compareWith]="compareSelectionTreeItems"
                    (ngModelChange)="setSelection($event)"
                >
                    <ng-container *ngFor="let item of savedSelectionNodeItems$ | async">
                        <option [ngValue]="item">
                            {{
                                '&nbsp;'.repeat((item.level - 1) * 3) +
                                    (item.level > 1 ? '\u21B3 ' : '') +
                                    item.name
                            }}
                        </option>
                    </ng-container>
                </select>
            </cds-select>
            <ng-container *ngrxLet="isSharedCase$ as isSharedCase">
                <cds-button
                    size="sm"
                    action="outline"
                    [disabled]="isSharedCase"
                    (click)="addHierarchicalSelectionNode()"
                >
                    Send down
                </cds-button>
                <cds-button
                    size="sm"
                    action="outline"
                    [disabled]="
                        currentHierarchicalSelectionIsRoot ||
                        isSharedCase ||
                        isTopLevelSelection(currentHierarchicalSelectionNodeItem)
                    "
                    (click)="removeHierarchicalSelectionNode(currentHierarchicalSelectionNodeItem)"
                >
                    Send up
                </cds-button>
                <button
                    size="sm"
                    [disabled]="
                        currentHierarchicalSelectionIsRoot ||
                        isSharedCase ||
                        isTopLevelSelection(currentHierarchicalSelectionNodeItem)
                    "
                    (click)="
                        removeHierarchicalSelectionNodeRecursively(
                            currentHierarchicalSelectionNodeItem
                        )
                    "
                    class="icon-button"
                >
                    <cds-icon shape="trash"></cds-icon>
                </button>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
